export const slide = {
    initial: { x: "calc(100% + 500px)" },
    enter: { x: "0", transition: { duration: 1.3, type: "spring", stiffness: 350, damping: 30 } },
    exit: { x: "calc(100% + 500px)", transition: { duration: 1.3, type: "spring", stiffness:350, damping: 30 } }
}